/**
 * WebGLのウォークポイントを作るファイル
 */

import {
  BoxBufferGeometry,
  PlaneBufferGeometry,
  RawShaderMaterial,
  Mesh,
  TextureLoader,
  MeshBasicMaterial
} from "three";
import TWEEN from "@tweenjs/tween.js";

import configRoom from "@/config/room";

import vs from "./glsl/NodeIcon.vs";
import fs from "./glsl/NodeIcon.fs";

import store from "@/store";

const SIZE = 0.4;
const APLHA_MAX = 0.7; // 透過率の最大値

export default class Node extends Mesh {
  /**
   * @param {*} data - APIのwalk_through.node[x]（参照: https://github.com/lifull/ai-madori-webviewer/wiki/API#1-1-%E5%BA%A7%E6%A8%99%E6%83%85%E5%A0%B1）
   */
  constructor(data) {
    const geometry = new BoxBufferGeometry(SIZE, SIZE, SIZE);
    const material = new MeshBasicMaterial({
      color: 0x00ff00,
      opacity: 0,
      transparent: true,
      depthTest: false
    });

    super(geometry, material);
    this.name = "node";
    this.node_id = data.node_id;
    this.next_id = data.next_id;
    this.renderOrder = 10;

    const { meterPerPixel } = store.state.webgl;
    const x = data.x * meterPerPixel;
    const z = data.y * meterPerPixel;
    this.position.set(x, configRoom.nodeIconPosY, z);

    // icon追加
    const planeGeometry = new PlaneBufferGeometry(SIZE, SIZE);
    const planeMaterial = new RawShaderMaterial({
      uniforms: {
        tex: { value: null },
        texAlpha: { value: null },
        alpha: { value: 1.0 }
      },
      vertexShader: vs,
      fragmentShader: fs,
      transparent: true,
      depthTest: false
    });
    this.icon = new Mesh(planeGeometry, planeMaterial);
    this.icon.rotation.x = Math.PI / -2;
    this.icon.renderOrder = 10;
    this.add(this.icon);

    const loader = new TextureLoader();
    const imgEx = store.state.imgEx;
    const ex = imgEx === "webp" ? "webp" : "png";
    loader.load(
      `${process.env.BASE_URL}img/tex/${imgEx}/pin_place.${ex}`,
      tex => {
        this.icon.material.uniforms.tex.value = tex;
      }
    );
    loader.load(
      `${process.env.BASE_URL}img/tex/${imgEx}/pin_place_alpha.${ex}`,
      tex => {
        this.icon.material.uniforms.texAlpha.value = tex;
      }
    );
  }

  /**
   * ウォークポイントを表示させる
   * @param {boolean} isAnimation - アニメーションの有無
   */
  on(isAnimation) {
    if (!isAnimation) {
      this.icon.material.uniforms.alpha.value = 1;
      this.visible = true;
      return;
    }

    new TWEEN.Tween({ progress: 0 })
      .to(
        {
          progress: 1
        },
        500
      )
      .easing(TWEEN.Easing.Linear.None)
      .onStart(() => {
        this.icon.material.uniforms.alpha.value = 0;
        this.visible = true;
      })
      .onUpdate(vals => {
        this.icon.material.uniforms.alpha.value = vals.progress * APLHA_MAX;
      })
      .onComplete(() => {
        this.icon.material.uniforms.alpha.value = APLHA_MAX;
      })
      .start();
  }

  /**
   * ウォークポイントを非表示させる
   * @param {boolean} isAnimation - アニメーションの有無
   */
  off(isAnimation) {
    if (!isAnimation) {
      this.icon.material.uniforms.alpha.value = 0;
      this.visible = false;
      return;
    }

    new TWEEN.Tween({ progress: 0 })
      .to(
        {
          progress: 1
        },
        500
      )
      .easing(TWEEN.Easing.Linear.None)
      .onStart(() => {
        this.icon.material.uniforms.alpha.value = APLHA_MAX;
      })
      .onUpdate(vals => {
        this.icon.material.uniforms.alpha.value = APLHA_MAX - vals.progress;
      })
      .onComplete(() => {
        this.icon.material.uniforms.alpha.value = 0;
        this.visible = false;
      })
      .start();
  }
}
